import React from 'react';
import './Admin.css';
import CreateKPI2GraphMode from './content/kpi_2_graph_modes/CreateKPI2GraphMode';
import SearchKPI2GraphMode from './content/kpi_2_graph_modes/SearchKPI2GraphMode';
import CreateKPI7GraphMode from './content/kpi_7_graph_modes/CreateKPI7GraphMode';
import SearchKPI7GraphMode from './content/kpi_7_graph_modes/SearchKPI7GraphMode';

export const admin_routes = {
    'kpi 2 graph modes':{
        icon: "fas fa-chart-area",
        subMenu:{
            "search": {
                icon: "fas fa-filter",
                component: <SearchKPI2GraphMode/>
            },
            "add graph mode": {
                icon: "fas fa-plus-circle",
                component: <CreateKPI2GraphMode/>
            }
        }
    },
    'kpi 7 graph modes':{
        icon: "fas fa-chart-area",
        subMenu:{
            "search": {
                icon: "fas fa-filter",
                component: <SearchKPI7GraphMode/>
            },
            "add graph mode": {
                icon: "fas fa-plus-circle",
                component: <CreateKPI7GraphMode/>
            }
        }
    }
}